/* ==========================================================================
   Mobile Icon Animation
   ========================================================================== */

// ...
import gsap from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

var tl = gsap.timeline({
    paused: true,
    reversed: true,
    defaults: { duration: 0.3 },
  }),
  wave = document.getElementById("wave1");

tl.to(wave, { morphSVG: "#xline1", ease: "power1.inOut" });

var checkBox = document.getElementById("menu-toggle") as HTMLInputElement;

checkBox.addEventListener("click", playMorph);

function playMorph() {
  tl.reversed() ? tl.play() : tl.reverse();
}
